import { TableFilterTypesEnum } from '../../../../../Enums';

export const headerData = [
  {
    id: 1,
    label: 'activity_type_name',
    input: 'activityTypeName',
    searchableKey: 'activityName',
    filterType: TableFilterTypesEnum.textInput.key,
},
{
    id: 2,
    label: 'assigned_to',
    input: 'assignedTo',
},
{
    id: 3,
    label: 'category_name',
    input: 'categoryName',
},
{
    id: 4,
    label: 'comments',
    input: 'comments',
},
{
    id: 5,
    label: 'contact_name',
    input: 'contactName',
},
{
    id: 6,
    label: 'created_by_name',
    input: 'createdByName',
    searchableKey: 'createdBy',
    filterType: TableFilterTypesEnum.textInput.key,
  },
  {
    id: 7,
    label: 'created_on',
    input: 'createdOn',
    searchableKey: 'createdDate',
    isDate: true,
    dateFormat: 'DD/MM/YYYY - hh:mm A',
    filterType: TableFilterTypesEnum.datePicker.key,
  },
];
